export enum ShoppingStoreActions {
  GET_SHOPPING_LIST = '[Shopping] -> GET SHOPPING LIST',
  SAVE_SHOPPING_LIST = '[Shopping] -> SAVE SHOPPING LIST',

  START_INGREDIENT_ADDITION = '[Shopping] -> START INGREDIENT ADDITION',
  ADD_INGREDIENT = '[Shopping] -> ADD INGREDIENT',

  START_INGREDIENTS_ADDITION = '[Shopping] -> START INGREDIENTS ADDITION',
  ADD_INGREDIENTS = '[Shopping] -> ADD INGREDIENTS',

  START_INGREDIENT_DELETION = '[Shopping] -> START INGREDIENT DELETION',
  DELETE_INGREDIENT = '[Shopping] -> DELETE INGREDIENT',

  START_INGREDIENTS_DELETION = '[Shopping] -> START INGREDIENTS DELETION',
  DELETE_INGREDIENTS = '[Shopping] -> DELETE INGREDIENTS',

  START_INGREDIENT_UPDATE = '[Shopping] -> START INGREDIENT UPDATE',
  UPDATE_INGREDIENT = '[Shopping] -> UPDATE INGREDIENT',

  OPEN_INGREDIENT_EDIT_FORM = '[Shopping] -> OPEN INGREDIENT EDIT FORM',
  CLOSE_INGREDIENT_EDIT_FORM = '[Shopping] -> CLOSE INGREDIENT EDIT FORM',

  CLEAR_ACTION_STATES = '[Shopping] -> CLEAR ACTION STATES'
}
